import { TaskSuggestionCustomData } from '../../datapoints';

export default function getTaskSuggestionCustomData(
    extractionId?: string
): TaskSuggestionCustomData {
    return {
        extractionId: extractionId,
    };
}
